/**
 * Parses filename from Content-Disposition (supports filename= and filename*=UTF-8'').
 */
export const parseFilenameFromContentDisposition = (contentDisposition) => {
    if (!contentDisposition) {
        return 'download.pdf';
    }

    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
    if (utf8Match) {
        try {
            return decodeURIComponent(utf8Match[1].replace(/['"]/g, ''));
        } catch (e) {
            // fall through to filename=
        }
    }

    const quotedMatch = /filename="([^"]+)"/i.exec(contentDisposition);
    if (quotedMatch) {
        return quotedMatch[1];
    }

    const unquotedMatch = /filename=([^;]+)/i.exec(contentDisposition);
    if (unquotedMatch) {
        return unquotedMatch[1].trim().replace(/^['"]|['"]$/g, '');
    }

    return 'download.pdf';
};

export const downloadBlobResponse = (response, defaultFilename = 'download.pdf') => {
    const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const fileName = parseFilenameFromContentDisposition(response.headers['content-disposition']) || defaultFilename;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
